module.exports = __webpack_public_path__ + "static/media/mute.34e5527a.png";